// extracted by mini-css-extract-plugin
export default {"lightMain":"App_lightMain__oIk1D","darkMain":"App_darkMain__fLaZs"};